const versionList = {
  v1: '1',
  v2: '2',
  v3: '3',
};

export default versionList;
